import { useEffect } from "react";
import config from "./apiService";
import Auth from "./auth";
import { confirmedAlert } from "view/component/Alert";
const WithAxios = ({ children }) => {
  const auth = new Auth();
  useEffect(() => {
    config.service.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status == 403) {
          confirmedAlert(
            "Error Sesi Habis",
            "Sesi Anda telah habis, Anda Akan logout dan silahkan login kembali",
            function (confirmed) {
              if (confirmed) {
                auth.logout();
              }
            }
          );
        } else {
          return error.response.data;
        }
      }
    );
  }, []);

  return children;
};

export default WithAxios;
